module.exports = __webpack_public_path__ + "img/orange_073.4d27a078.png";